import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, LogOut } from "lucide-react";
import useIdleTimeout from "../hooks/useIdleTimeout";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function IdleGuard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.info("Sessione scaduta per inattività");
    navigate("/login", { replace: true });
  };

  const { warning, remaining, extend } = useIdleTimeout({
    enabled: !!user,
    onIdle: handleLogout,
  });

  if (!user || !warning) return null;

  const seconds = Math.max(0, Math.round(remaining / 1000));

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/60" data-testid="idle-warning">
      <div className="card-shell max-w-sm w-full p-6 text-center">
        <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4" style={{ background: "#FFF4E5", color: "#8A4D0F" }}>
          <Clock className="w-7 h-7" />
        </div>
        <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "Manrope" }}>Sessione in scadenza</h3>
        <p className="text-sm mb-4" style={{ color: "var(--text-muted)" }}>
          Per inattività verrai disconnesso tra
        </p>
        <div className="text-4xl font-extrabold mb-5" style={{ color: "var(--accent)", fontFamily: "Manrope" }} data-testid="idle-countdown">
          {seconds}s
        </div>
        <div className="flex gap-2">
          <button onClick={handleLogout} className="btn-secondary flex-1" data-testid="idle-logout">
            <LogOut className="w-4 h-4" /> Esci ora
          </button>
          <button onClick={extend} className="btn-primary flex-1" data-testid="idle-extend">
            Continua
          </button>
        </div>
      </div>
    </div>
  );
}
